import { hysteriFetch, wrappers } from 'hysterics';

const locationServiceFetcher = hysteriFetch('location-service.rest-v1');

export const API = {
	getDistanceFromLS: async (
		userPostalCode,
		vehicleLat,
		vehicleLong,
		locale
	) => {
		const fetchHeaders = new Headers();
		fetchHeaders.append('pragma', 'cache');
		fetchHeaders.append('cache-control', 'cache');
		fetchHeaders.append('Accept', 'application/json');
		fetchHeaders.append('Content-Type', 'application/json');

		try {
			const locationFetch = await locationServiceFetcher(
				`/api/widget/ws-vehicle-location/getDistance/${userPostalCode}/${vehicleLat}/${vehicleLong}/${locale}`,
				{
					method: 'POST',
					headers: fetchHeaders
				},
				{
					[wrappers.retry.contextKey]: {
						retries: 1
					}
				}
			);
			return locationFetch;
		} catch (err) {
			return `Error retrieving location: ${err.message}`;
		}
	}
};
